import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const TableLineageUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
  query TableLineageUpstreamDataQualityWarningsQuery(
    $tableId: ID!
    $first: Int!
    $offset: Int!,
    $publishedConnectionsLineageEnabled: Boolean!
  ) {
    databaseTables(filter: { id: $tableId }) {
      id
      name
      __typename
      dataQualityWarnings {
        isActive
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
      upstreamDataQualityWarningsConnection(
        filter: { isActive: true }
        first: $first
        offset: $offset
        orderBy: { field: IS_SEVERE, direction: DESC }
      ) {
        totalCount
        nodes {
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
  ${DataQualityWarningFragmentGql}
  ${DataQualityWarningAssetFragmentGql}
`;
